if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        console.log('Fetching recommendations from:', this.dataset.url);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            console.log('Response received:', responseText.substring(0, 500));
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            console.log('Recommendations element:', recommendations);
            console.log('Recommendations HTML length:', recommendations?.innerHTML.trim().length);
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              console.log('Products found!');
              const productCards = recommendations.querySelectorAll('.product-card');
              console.log('Number of products:', productCards.length);
              productCards.forEach((card, index) => {
                const title = card.querySelector('.card-title')?.textContent.trim();
                console.log(`Product ${index + 1}:`, title);
              });
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              console.log('No products found');
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
